<app-topnav [llttfPage]="llttfPage"></app-topnav>

<div class="container">
  <div class="content" role="main">
    <div class="cmha-participant-page">
      <div class="participant-banner" [ngClass]="participantClassByRole">
        <div class="container">
          <h2>{{'browseCourseText'|translate:translations}}</h2>

          <div class="filterForm default-bg">
            <fieldset>
              <mat-form-field appearance="outline" floatLabel="always" >
                <mat-label>{{'searchButtonText'|translate:translations}}</mat-label>
                <input matInput class="form-control-textbox" name="filterSearch" [(ngModel)]="queryFilter.CourseKeyword" />
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>{{'tagText'|translate:translations}}</mat-label>
                <mat-select placeholder="Select" name="filtercoursetag" multiple [(ngModel)]="queryFilter.ParticipantCourseTags">
                  @for (tag of tags; track tag) {
                    <mat-option [value]="tag.id">{{ getTagLabel(tag) }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>{{'statusText'|translate:translations}}</mat-label>
                <mat-select placeholder="Select" name="filtercoursestatus" multiple [(ngModel)]="queryFilter.ParticipantCourseEnrollmentStatus">
                  @for (cs of participantCourseStatus; track cs) {
                    <mat-option [value]="cs.key">{{ getStatusLabel(cs) }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>{{'courseLanguageFilterLabel'|translate:translations}}</mat-label>
                <mat-select placeholder="Select" name="filtercourselanguage" [(ngModel)]="queryFilter.CourseLanguage">
                  @for (lang of courseLanguages; track lang) {
                    <mat-option [value]="lang.id">{{ getLanguageLabel(lang) }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </fieldset>
            <div class="courses-filter-actions">
              <button
                type="button"
                class="courses-filter-btn courses-filter-btn--search"
                (click)="search()"
                #submitButton>
                {{'searchButtonText'|translate:translations}}
              </button>
              <button
                type="button"
                class="courses-filter-btn courses-filter-btn--reset"
                (click)="resetFilters()">
                {{'resetButtonText'|translate:translations}}
              </button>
            </div>
          </div>
          <div class="h-30"></div>
        </div>
      </div>

      <div class="h-30"></div>
      <div class="tableContents">
        <ng-container #courseContainer *ngTemplateOutlet="courseTable; context: {data: courseList, headerVisible: true}"></ng-container>
        <mat-paginator #paginator [length]="this.totalRecords" [pageSize]="25" [hidden]="this.totalRecords === 0"
        [pageSizeOptions]="[10, 25, 50]" (page)="handlePageEvent($event)" ariaLabel=''></mat-paginator>
      </div>
    </div>

    <div class="h-30"></div>
  </div>
</div>


<ng-template #courseTable let-data="data" let-headerVisible="headerVisible">

  <app-no-results #noResults></app-no-results>

  @if (this.hasRetiredCourse) {
    <div class="course-retired-notice">
      {{'coursesRetiredNoticeText'|translate:translations}}
    </div>
  }

  @if (data.length > 0) {
    <mat-tab-group class="course-listing-tabs">
      <ng-container>
        <mat-tab label="Tab 1" tabindex="0" >
          <ng-template mat-tab-label><fa-icon [icon]="gridIcon"></fa-icon> {{'gridText'|translate:translations}}</ng-template>
          @if (data.length > 0) {
            <div class="grid grid-course">
              @for (course of data; track course) {
                <div class="grid-item">
                  <div class="item-content">
                    <div class="status-bar">
                      <app-course-enrollment-status [course]="course"></app-course-enrollment-status>
                      <app-retired-course [course]="course"></app-retired-course>
                      <app-favourite-course [course]="course" [userId]="loggedInUserPublicId" (notifyParent)="handleFavouriteClick()"></app-favourite-course>
                    </div>
                    <div class="h-30"></div>
                    <a routerLink="/participants/courses/view-course/{{course.courseRecordId}}">
                      <div class="item-thumbnail">
                        <img [src]="course.thumbnailUrl">
                      </div>
                      <div class="item-title">{{course.courseName}}</div>
                      <div class="course-progress course-progress--sm" [attr.aria-label]="getProgressLabel(course) + ' progress'">
                        <div class="course-progress__track">
                          <div class="course-progress__fill" [style.width.%]="getProgressPercent(course)"></div>
                        </div>
                        <span class="course-progress__label">{{ getProgressLabel(course) }}</span>
                      </div>
                      <div class="item-content" [innerHTML]="course.courseShortDescription"></div>
                      <app-tags [items]="course.tags"></app-tags>
                    </a>
                  </div>
                </div>
              }
              <div class="h-30"></div>
            </div>
          }
        </mat-tab>
      </ng-container>
      <ng-container>
        <mat-tab label="Tab 2" tabindex="1" >
          <ng-template mat-tab-label><fa-icon [icon]="listIcon"></fa-icon> {{'listText'|translate:translations}}</ng-template>
          @if (data.length > 0) {
            <div class="list list-course">
              @for (course of data; track course) {
                <div class="list-item">
                  <div class="item-content">
                    <div class="status-bar">
                      <app-course-enrollment-status [course]="course"></app-course-enrollment-status>
                      <app-retired-course [course]="course"></app-retired-course>
                      <app-favourite-course [course]="course" [userId]="loggedInUserPublicId" (notifyParent)="handleFavouriteClick()"></app-favourite-course>
                    </div>
                    <div class="h-30"></div>
                    <a routerLink="/participants/courses/view-course/{{course.courseRecordId}}">
                      <div class="item-thumbnail">
                        <img [src]="course.thumbnailUrl">
                      </div>
                      <div class="item-description">
                        <div class="item-title">{{course.courseName}}</div>
                        <div class="course-progress course-progress--sm" [attr.aria-label]="getProgressLabel(course) + ' progress'">
                          <div class="course-progress__track">
                            <div class="course-progress__fill" [style.width.%]="getProgressPercent(course)"></div>
                          </div>
                          <span class="course-progress__label">{{ getProgressLabel(course) }}</span>
                        </div>
                        <div class="item-content" [innerHTML]="course.courseShortDescription"></div>
                        <app-tags [items]="course.tags"></app-tags>
                      </div>
                    </a>
                  </div>
                </div>
              }
              <div class="h-30"></div>
            </div>
          }
        </mat-tab>
      </ng-container>
    </mat-tab-group>
  }

</ng-template>



<app-footer [bbapp]="true"></app-footer>
